// extracted by mini-css-extract-plugin
module.exports = {"detailsHeader":"WebhookEndpointDetails_detailsHeader__1HN0q"};